/**
 * author       : zwl
 * createTime   : 2018/7/18 上午9:34
 * description  :
 */
import api from 'util/axios'

export function receiptList (params, receiptId) {
  let url = null
  if (!receiptId) {
    url = '/orderReceipt/list/' + params.appId
  } else {
    url = '/orderReceipt/list/' + params.appId + '?receiptId=' + receiptId
  }
  return api({
    method: 'post',
    url: url,
    data: params
  })
}

export function selectLikeArea (appId, areaName) {
  return api({
    method: 'get',
    url: `/orderReceipt/selectLikeArea/${appId}?areaName=${areaName}`
  })
}

export function quickPage (params) {
  return api({
    method: 'post',
    url: `/orderReceipt/quickPage/${params.appId}`,
    data: params
  })
}

export function createReceiptOrder (params) {
  return api({
    method: 'post',
    url: `/orderReceipt/${params.appId}`,
    data: params
  })
}

export function updateReceiptOrder (receiptId, params) {
  return api({
    method: 'put',
    url: `/orderReceipt/${receiptId}/${params.appId}`,
    data: params
  })
}
export function deleteReceiptOrder (receiptId, params) {
  return api({
    method: 'delete',
    url: `/orderReceipt/${receiptId}/${params.appId}`,
    data: params
  })
}
export function updateReceiptSupply (receiptId, params) {
  return api({
    method: 'put',
    url: `/orderReceipt/updateReceiptSupply/${receiptId}/${params.appId}`,
    data: params
  })
}
